import React from 'react';
// import injectSheet from 'react-jss';



// TODO: placeholder image?



const Image = ({
  width = 64,
  height = null,
  howRatio = 1,  // height-over-width aspect ratio
  src = null,
  // type = 'basic',
  alt = '',
  style = {},
  className
}) => {
  const _height = (height === null
    ? width * howRatio
    : height
  );

  return (
    <img
      className={className}
      style={style}
      src={src}
      width={width}
      height={_height}
      alt={alt}
    />
  );
};
// Image = injectSheet({
//   basic: {
//
//   },
//   tinyProfilePic: {
//     borderRadius: '4px',
//   },
// })(Image);


export default Image;
// export {
//   Image,
// }



// WEBPACK FOOTER //
// ./src/components/elems/Image.js